export default __webpack_public_path__ + "static/media/card3.106e451e.svg";